import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "card-interactive-header" }
const _hoisted_3 = { class: "row" }

import TextBase, { TextType } from '@/design-system/atoms/TextBase.vue'
import InfoButton from './InfoButton.vue'
import ButtonFullscreen from '@/design-system/atoms/buttons/ButtonFullscreen.vue'

type Props = {
  title: string
  titleType?: TextType
  titleTypeFullscreen?: TextType
  showInfo?: boolean
  showControls?: boolean
  enableFullscreen?: boolean
  fullscreen?: boolean
}

type Emits = {
  (e: 'toggleFullscreen'): void
  (e: 'toggleShowInfo'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardInteractiveHeader',
  props: {
    title: {},
    titleType: { default: 'paragraph' },
    titleTypeFullscreen: { default: 'h4' },
    showInfo: { type: Boolean, default: false },
    showControls: { type: Boolean, default: false },
    enableFullscreen: { type: Boolean, default: false },
    fullscreen: { type: Boolean, default: false }
  },
  emits: ["toggleFullscreen", "toggleShowInfo"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

function onToggleInfoClick() {
  emit('toggleShowInfo')
}

function onToggleFullscreenClick() {
  emit('toggleFullscreen')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.fullscreen)
        ? (_openBlock(), _createBlock(TextBase, {
            key: 0,
            text: _ctx.title,
            type: _ctx.titleTypeFullscreen,
            weight: "bold"
          }, null, 8, ["text", "type"]))
        : (_openBlock(), _createBlock(TextBase, {
            key: 1,
            text: _ctx.title,
            type: _ctx.titleType,
            weight: "bold"
          }, null, 8, ["text", "type"])),
      _createElementVNode("div", {
        class: _normalizeClass(["card-interactive-controls", { fullscreen: _ctx.fullscreen }])
      }, [
        (_ctx.showControls)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _renderSlot(_ctx.$slots, "controls"),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "vertical-divider" }, null, -1))
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showInfo)
            ? (_openBlock(), _createBlock(InfoButton, {
                key: 0,
                state: false,
                class: _normalizeClass(["icon", { fullscreen: _ctx.fullscreen }]),
                onClick: onToggleInfoClick
              }, null, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.enableFullscreen)
            ? (_openBlock(), _createBlock(ButtonFullscreen, {
                key: 1,
                class: _normalizeClass(["icon", { fullscreen: _ctx.fullscreen }]),
                fullscreen: _ctx.fullscreen,
                onToggleFullscreen: onToggleFullscreenClick
              }, null, 8, ["class", "fullscreen"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})